import React from 'react';
import Modal from '../Modal';
import VideoPlayer from '../../videoplayer/VideoPlayer';

import './VideoPlayerModal.scss';

const VideoPlayerModal = ({ open, close, url = '' }) => {
  const extension = url.split('.').pop();

  const videoPlayerOptions = {
    autoplay: true,
    muted: false,
    sources: [{
      src: url,
      type: `video/${extension}`,
    }],
  };

  return !open ? null : (
    <Modal className="video-player-modal" theme="dark" open={open} handleClose={() => close()}>
      <VideoPlayer {...videoPlayerOptions} noTrack />
    </Modal>
  );
};

export default VideoPlayerModal;
